<template>
  <div class="cencent">
    <div class="title">
      <el-button size="mini" type="primary" @click="class_status = true"
        >新增</el-button
      >
    </div>
    <el-table
      :header-cell-style="{ background: '#000', color: '#fff', border: 0 }"
      :data="list"
      stripe
      border
      height="calc(100% - 60px)"
      show-overflow-tooltip="true"
    >
      <el-table-column type="index" width="80" align="center" label="序号">
      </el-table-column>
      <el-table-column prop="name" align="center" label="菜单名">
      </el-table-column>
      <el-table-column prop="username" align="center" label="icon">
        <template slot-scope="scope">
          <i :class="scope.row.icon"></i>
        </template>
      </el-table-column>

      <el-table-column align="center" label="所属平台">
        <template slot-scope="scope">
          <div>
            {{
              scope.row.proth == "1"
                ? "服务商后台"
                : scope.row.proth == "2"
                ? "小程序"
                : scope.row.proth == "3"
                ? "代理后台"
                : "平台"
            }}
          </div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作">
        <template slot-scope="scope">
          <div style="display: flex; justify-content: space-around">
            <div class="btn-txt" @click="edit_info(scope.row)">编辑</div>
            <div
              class="btn-error"
              v-if="scope.row.is_delete == 0"
              @click="update_status(scope.row, 1)"
            >
              停用
            </div>
            <div
              class="btn-success"
              v-else
              @click="update_status(scope.row, 0)"
            >
              启用
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!--新增菜单弹框-->
    <el-dialog
      width="38%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
      destroy-on-close
      :visible.sync="class_status"
    >
      <el-form size="mini" :model="form" label-width="120px">
        <el-form-item required label="菜单名称">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item required label="icon">
          <i
            v-if="form.icon"
            style="font-size: 30px; margin: 10px; cursor: pointer"
            :class="form.icon"
          ></i>
          <span class="btn-txt" @click="selecticon">选择</span>
        </el-form-item>

        <el-form-item label="平台" required>
          <el-radio v-model="form.proth" label="1">服务商后台</el-radio>
          <el-radio v-model="form.proth" label="2">小程序</el-radio>
          <el-radio v-model="form.proth" label="3">代理后台</el-radio>
          <el-radio v-model="form.proth" label="4">管理后台</el-radio>
        </el-form-item>
      </el-form>
      <div style="text-align: center; padding: 20px">
        <el-button type="primary" @click="onSubmit" size="mini"
          >保 存</el-button
        >
        <el-button @click="class_status = false" size="mini">关 闭</el-button>
      </div>
    </el-dialog>
    <!--选择ICON弹框-->
    <el-dialog
      width="38%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      top="40px"
      append-to-body
      destroy-on-close
      :visible.sync="selecticon_status"
      v-if="selecticon_status"
    >
    <div style="text-align: center; padding: 20px">
        <el-button @click="selecticon_status = false" size="mini"
          >关 闭</el-button
        >
      </div>
      <icon @change="iconchange"></icon>
    </el-dialog>
  </div>
</template>

<script>
import u from "../../../assets/js/util.js";
import icon from "../util/selecticon";

export default {
  components: {
    icon,
  },
  name: "menu_v1",
  data() {
    return {
      u: u,
      page: {
        all_size: 0,
        page: 1,
        size: 10,
      },
      class_status: false,
      changefanwei: false,
      field_edit_status: false,
      selecticon_status: false,
      form: {
        icon: "",
        _id: "",
        name: "",
        proth: "1",
        is_delete: 0,
      },
      editfield: {},
      list: [],
    };
  },
  async mounted() {
    this.get_list();
  },
  methods: {
    field_add_statusfunctio() {
      this.reloaddata();
      this.field_add_status = true;
    },
    iconchange(e) {
      this.form.icon = e;
      this.selecticon_status = false;
    },
    selecticon() {
      this.selecticon_status = true;
    },
    async onSubmit() {
      if (!this.form.name) {
        u.error("名称不能空");
        return;
      }
      if (!this.form.icon) {
        u.error("图标不能空");
        return;
      }
      var res = await u.post("admin", "menu", this.form);
      if (res !== false) {
        this.class_status = false;
        this.form = {
          icon: "",
          name: "",
          proth: "1",
          is_delete: 0,
        };
        this.selectfieldchangevalue = "";
        this.get_list();
      }
    },
    async update_status(e, status) {
      var from = e;
      from.is_delete = status;
      var res = await u.post("admin", "menu", from);
      if (res !== false) {
        this.class_status = false;
        this.form = {
          icon: "",
          name: "",
          proth: "1",
          is_delete: 0,
        };
        this.get_list();
      }
    },
    edit_info(data) {
      this.form = {
        icon: data.icon,
        is_delete: 0,
        name: data.name,
        proth: data.proth,
        _id: data._id,
      };
      this.class_status = true;
    },
    async get_list() {
      var list = await u.post("admin", "querymenu", {});

      this.list = list;
    },
  },
};
</script>

<style scoped>
/deep/ .el-dialog__body {
  height: 90%;
}
</style>



// WEBPACK FOOTER //
// src/page/module/admin/class_v1.vue